import React from 'react'
import { Base, ChevronIcon } from '@itsrever/design-system'
import { useTranslation } from 'react-i18next'

const {
  Button,
  MenuRoot,
  MenuTrigger,
  MenuPortal,
  MenuPositioner,
  MenuPopup,
  MenuRadioGroup,
  MenuRadioItem
} = Base

export const languages = {
  DE: 'custom_copies.de',
  EN: 'custom_copies.en',
  FR: 'custom_copies.fr',
  IT: 'custom_copies.it',
  PT: 'custom_copies.pt',
  ES: 'custom_copies.es',
  NL: 'custom_copies.nl',
  PL: 'custom_copies.pl',
  CS: 'custom_copies.cs',
  SK: 'custom_copies.sk'
}

const LANGUAGE_CODES = Object.keys(languages)

interface LanguageSelectorProps {
  selectedLang: string
  onChange: (lang: string, index: number) => void
}

export const LanguageSelector: React.FC<LanguageSelectorProps> = ({
  selectedLang,
  onChange
}) => {
  const { t } = useTranslation()

  return (
    <MenuRoot>
      <MenuTrigger render={<Button variant="secondary" className="w-32" />}>
        {t(languages[selectedLang as keyof typeof languages])}
        <ChevronIcon />
      </MenuTrigger>
      <MenuPortal>
        <MenuPositioner sideOffset={6} align="start">
          <MenuPopup className="max-h-[var(--available-height)] overflow-y-auto">
            <MenuRadioGroup
              value={selectedLang}
              onValueChange={(lang: string) =>
                onChange(lang, LANGUAGE_CODES.indexOf(lang))
              }
            >
              {Object.entries(languages).map(([lang, label]) => (
                <MenuRadioItem key={lang} value={lang}>
                  {t(label)}
                </MenuRadioItem>
              ))}
            </MenuRadioGroup>
          </MenuPopup>
        </MenuPositioner>
      </MenuPortal>
    </MenuRoot>
  )
}

export default LanguageSelector
